import { useEffect, useRef } from "react";

const VideoPlayer = ({ videoTrack, audioTrack, isLocal = false, isMuted = false, className = "" }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current || !videoTrack) return;
    videoTrack.play(containerRef.current);
    return () => {
      videoTrack.stop();
    };
  }, [videoTrack]);

  useEffect(() => {
    if (!audioTrack || isLocal) return;
    audioTrack.play();
    return () => {
      audioTrack.stop();
    };
  }, [audioTrack, isLocal]);

  return (
    <div
      ref={containerRef}
      className={className}
      style={{ width: "100%", height: "100%", background: "#1a1a2e" }}
    />
  );
};

export default VideoPlayer;
